import * as React from 'react';
import { Box } from '@mui/material';

function Root({ ...props }) {
  return (
    <Box
      {...props}
      sx={[
        {
          bgcolor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '80vh',
          minWidth: 320,
          position: 'relative'
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx])
      ]}
    />
  );
}

function Header(props) {
  return (
    <Box
      component="header"
      className="Header"
      {...props}
      sx={[
        {
          p: 1,
          gap: 1,
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid',
          borderColor: 'divider',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          height: '48px'
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx])
      ]}
    />
  );
}

function Main(props) {
  return (
    <Box
      component="main"
      className="Main"
      {...props}
      sx={[
        {
          p: 2,
          overflowY: 'auto',
          flex: 1,
          mt: '48px',
          mb: '48px'
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx])
      ]}
    />
  );
}

const LayoutComponents = { Root, Header, Main };

export default LayoutComponents;
